<template>
  <div class="trApplyAlter full-height linear-main3">
    <ld-header
      transparent
      white
      @click-left="back"
    >
      申请改签
    </ld-header>

    <div class="wrapper">
      <mescroll-vue :down="{use:false}">
        <div
          style="margin-bottom: 50px"
          class="pad8"
          v-if="oldDetail.orderNo"
        >
          <!-- 原订单信息 -->
          <div class="round-sm bg-white pad8 pb0">
            <stop-station
              class="van-hairline--bottom"
              :detail="oldDetail"
              train-no-class="main-color"
            />
            <van-row class="font12 pad8 bg-white text-center">
              <router-link
                to="/tr/OrderService"
                class="main-color"
              >
                {{ $t('F010','退改签规则') }}
              </router-link>
            </van-row>
          </div>

          <!-- 日期 -->
          <van-cell
            class="mt5"
            :title="trSearchInfo.byTrainDate"
            @click="showDate"
          >
            <van-icon
              class="calender-icon"
              slot="icon"
              name="calender-o"
            />
            <ld-button
              class="query-btn"
              slot="right-icon"
              size="sm"
              @click.stop="query"
              round
              main
            >
              查询车次
            </ld-button>
          </van-cell>

          <!-- 改签后火车信息 -->
          <div
            v-if="trSearchInfo.TrainDetail.trainNo"
            class="round-sm bg-white mt5 pad8 pb0"
          >
            <van-tag type="danger">
              改
            </van-tag>
            <stop-station
              class="van-hairline--bottom"
              :detail="trSearchInfo.TrainDetail"
            />
          </div>

          <!-- 乘机人列表 -->
          <div class="mt5">
            <van-checkbox-group v-model="CheckPsgList">
              <van-cell-group>
                <van-cell class="font-bold">
                  <h3>请选择需要改签的乘客</h3>
                </van-cell>
                <van-cell
                  v-for="(psg, i) in oldDetail.psgList"
                  clickable
                  :key="psg"
                  @click="checkBoxes(psg, i)"
                >
                  <div slot="title">
                    {{ psg.passengerName }}&nbsp;
                    ({{ psg.idCode ? psg.idCode.replace(/^(.{4})(?:\w+)(.{4})$/,
                                                        "\$1******\$2") : "" }})
                    <van-tag plain>
                      {{ psg.ticketTypeName }}
                    </van-tag>
                    <van-tag
                      v-if="psg.showRefundTag"
                      type="danger"
                    >
                      已申请退票
                    </van-tag>
                    <van-tag
                      v-else-if="psg.showChangeTag"
                      type="success"
                    >
                      已申请改签
                    </van-tag>
                  </div>

                  <div slot="label">
                    <van-row type="flex">
                      <van-col class="text-right">
                        手机号：
                      </van-col>
                      <van-col span="20">
                        {{ psg.phoneNumber }}
                      </van-col>
                    </van-row>

                    <van-row type="flex">
                      <van-col class="text-right">
                        席&nbsp;&nbsp;&nbsp;&nbsp;位：
                      </van-col>
                      <van-col span="20">
                        {{ psg.seatCode }}
                        {{ psg.seatTypeName }}
                      </van-col>
                    </van-row>

                    <van-row type="flex">
                      <van-col class="text-right">
                        费&nbsp;&nbsp;&nbsp;&nbsp;用：
                      </van-col>
                      <van-col
                        span="20"
                        class="orange"
                      >
                        {{ psg.ticketPriceStr }}
                      </van-col>
                    </van-row>
                  </div>

                  <van-checkbox
                    v-show="psg.abledRefund"
                    :name="psg"
                    ref="checkboxes"
                    slot="right-icon"
                  />
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>

          <!-- 选座 -->
          <check-seat
            v-if="acceptNoSeatShow && chooseSeatTypePic(newSeatDetail.seatType)"
            :value.sync="chooseSeats"
            :max="CheckPsgList.length"
            :train-type="trSearchInfo.TrainDetail.trainType"
            :seat-type="newSeatDetail.seatType"
            class="round-sm mt5"
          />

          <check-seat-offline
            v-if="acceptNoSeatShow && trSearchInfo.TravelVerificateType !== TravelVerificateType.slzx && !chooseSeatTypePic(newSeatDetail.seatType)"
            :value.sync="chooseSeats"
            :max="this.oldDetail.psgList.length"
            :train-type="trSearchInfo.TrainDetail.trainType"
            :seat-type="trSearchInfo.SeatDetail.seatType"
            class="round-sm mt5"
          />
          <van-cell
            v-if="acceptNoSeatShow && trSearchInfo.TravelVerificateType !== TravelVerificateType.slzx"
            class="accept-outseat round-sm mt5"
            :title="$t('I038','接受无座')"
            center
          >
            <van-switch
              slot="right-icon"
              v-model="acceptNoSeat"
              size="24px"
            />
          </van-cell>

          <!--          <van-cell-->
          <!--            class="accept-outseat round-sm mt5"-->
          <!--            :title="$t('I041','接受部分出票')"-->
          <!--            center-->
          <!--          >-->
          <!--            <van-switch-->
          <!--              slot="right-icon"-->
          <!--              v-model="acceptNoTotal"-->
          <!--              size="24px"-->
          <!--            />-->
          <!--          </van-cell>-->
          <van-cell
            v-if="trSearchInfo.TravelVerificateType !== TravelVerificateType.slzx"
            class="accept-outseat round-sm mt5"
            :title="$t('I042','接受其他座位')"
            center
          >
            <van-switch
              slot="right-icon"
              v-model="acceptOtherSeat"
              size="24px"
            />
          </van-cell>
          <!-- 企业改签原因 -->
          <van-cell
            class="mt5"
            title="企业改签原因(必填)"
          />
          <van-field
            class="m-b-5"
            is-link
            readonly
            v-model="changeReasonVip"
            placeholder="选择企业改签原因"
            @click="$refs['changeReason'].toggle()"
          />
          <ld-uploader
            class="mt5 round-sm overflow"
            v-if="id"
            :order-id="id"
            :glywlx="'11011'"
            :cjlx="2"
          />
        </div>

        <!--提交申请-->
        <ld-tabbar
          class="pad8"
          style="height: auto;"
        >
          <ld-button
            main
            round
            :disabled="!canSubmit"
            @click="toApplyAlter"
          >
            申请改签
          </ld-button>
        </ld-tabbar>
      </mescroll-vue>
    </div>
    <!-- 日历 -->
    <ld-calendar
      ref="date"
      type="single"
      @selected="getDate"
    />

    <!-- 企业改签原因列表 -->
    <!-- <cancel-reason
      ref="changeReason"
      title="选择改签原因"
      :par-no="145"
      @selected="reasonSelect"
    /> -->
    <cancel-reason
      ref="changeReason"
      title="选择改签原因"
      :par-no="11603043"
      @selected="reasonSelect"
    />
  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票申请改签页面
 * @desc 通过改变Store的trSearchInfo.path 跳转到火车票列表页面
 *       预订车次的时候 ‘传入当前地址 (tr/ApplyAlter/:id)’ 选择座席才能返回到当前页面
 * @param {String} id 火车票订单
 */

import { CellGroup, Cell, CheckboxGroup, Checkbox, Switch, Field, Tag } from 'vant'
import { mapState } from 'vuex'
import ldButton from 'Common/ldButton'
import cancelReason from 'Components/CancelReason'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import Bussiness from 'Utils/business'
import checkSeat from '../trQuery/trEdit/CheckSeat'
import StopStation from '../trQuery/StopStation'
import MescrollVue from 'mescroll.js/mescroll.vue'
import TrainBookInteractor, {TravelVerificateType} from 'Domain/use-cases/train-book-interactor'
import CheckSeatOffline from '../trQuery/trEdit/CheckSeatOffline'

import { getSysType } from 'CommonUtils/plus.js'
import { formatDate } from 'Utils/dateUtil'

import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'
import mixin from '../mixin'
import ldUploader from 'Components/ldUploader'


export default {
  name: 'TrApplyAlter',
  mixins: [mixin],
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Field.name]: Field,
    [Tag.name]: Tag,
    checkSeat,
    ldButton,
    cancelReason,
    ldTabbar,
    StopStation,
    ldCalendar: () => import('Common/ldCalendar'),
    MescrollVue,
    ldUploader,
    CheckSeatOffline
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      oldDetail: {},
      acceptNoSeat: false,
      acceptNoTotal: false, //接受部分出票
      acceptOtherSeat: false, //接受其他坐席
      chooseSeats: '',
      changeReasonVip: '',
      CheckPsgList: [],
      canSubmit: false,
      TravelVerificateType
    }
  },
  async created() {
    this.validAccount(this.id)
    this.getAlterData()

    this.getConfig()
  },
  methods: {
    chooseSeatTypePic(seatType){
      const SEATTYPES = ['9','M','O']
      if (SEATTYPES.includes(seatType)){
        return true
      }else {
        return false
      }
    },
    //获取火车票产品配置
    async getConfig () {
      this.$api['common/queryVipParameter']({
        paramNo:'11603003'
      }).then(res => {
        this.acceptOtherSeat = res.data.value1 === '1'
      })
    },
    checkBoxes (psg, i) {
      if (psg.abledRefund) {
        this.$refs['checkboxes'][i].toggle()
        this.oldDetail.psgList.forEach((psg, j)=> {
          if (psg.idCode === this.oldDetail.psgList[i].idCode) {
            this.$refs['checkboxes'][j].toggle()
          }
        })
      }
    },
    // 获取可改签的乘机人
    async getAlterData() {
      try {
        const { data } = await TrainOrderInteractor.getChangePsgList(this.id)
        this.oldDetail = data
        this.trSearchInfo.byTrainDate = this.oldDetail.fromDate

        if (this.oldDetail.productType === '1'){
          this.trSearchInfo.TravelVerificateType = this.TravelVerificateType['12306']
        }else if (this.oldDetail.productType === '2'){
          this.trSearchInfo.TravelVerificateType = this.TravelVerificateType.emp
        }else if (this.oldDetail.productType === '3'){
          this.trSearchInfo.TravelVerificateType = this.TravelVerificateType.emp
        }else if (this.oldDetail.productType === '4'){
          this.trSearchInfo.TravelVerificateType = this.TravelVerificateType.tgWy
        }else if(this.oldDetail.productType === '5'){
          this.trSearchInfo.TravelVerificateType = this.TravelVerificateType.slzx
        }

        /**
                 * 开车前48h以上，可改签预售期内的车次；
                 * 开车前48h以内，可改签从办理改签之时到票面日期当日24：00之间的任意车次；
                 * 过了发车时间，可改签票面日期当天24点之前的车次
                 */
        if (!Bussiness.DetectorChangeTime(this.oldDetail, true)) {
          this.trSearchInfo.MAX_DATE = this.oldDetail.fromDate
        }
        /**
                 * 如果订单中只有一个乘客，默认的勾选上
                 */
        this.$nextTick(() => {
          if (this.oldDetail.psgList && this.oldDetail.psgList.length === 1){
            this.checkBoxes(this.oldDetail.psgList[0], 0)
          }
        })
      } catch (error) {
        if (typeof error === 'string') throw error
      }
    },
    //查询车次
    async query () {
      let store = {
        fromStation: this.oldDetail.fromStationName,
        toStation: this.oldDetail.toStationName,
        fromStationCode: this.oldDetail.fromStationCode,
        toStationCode: this.oldDetail.toStationCode,
        path: `/tr/ApplyAlter/${this.id}`
      }
      Object.assign(this.trSearchInfo, store)
      this.$router.push('/tr/trList')
    },
    /**
     * 选择企业改签原因
     */
    reasonSelect (reason) {
      this.changeReasonVip = reason.cName
    },
    showDate() {
      this.$refs.date.toggle({
        defaultDate:this.trSearchInfo.byTrainDate,
        minDate:this.trSearchInfo.MIN_DATE,
        maxDate:this.trSearchInfo.MAX_DATE,
      })
    },
    getDate(date){//日期回调
      this.trSearchInfo.byTrainDate = date
    },
    //提交改签申请
    async toApplyAlter () {
      try {
        let params = {
          'acceptNoseat': this.acceptNoSeat ? '1': '0',
          'acceptNoTotal': this.acceptNoTotal ? '1': '0',
          'acceptOtherSeat': this.acceptOtherSeat ? '1': '0',
          'changeReasonVip': this.changeReasonVip,
          'newFromStationCode': this.trSearchInfo.TrainDetail.fromStationCode,
          'newFromDate': this.trSearchInfo.TrainDetail.byTrainDate,
          'newFromTime': this.trSearchInfo.TrainDetail.startTime,
          'newSeatType': this.newSeatDetail.seatType,
          'newTicketPrice': this.newSeatDetail.price,
          'newToDate': formatDate(this.trSearchInfo.TrainDetail.byTrainDate, this.trSearchInfo.TrainDetail.arriveDays).date,
          'newToStationCode': this.trSearchInfo.TrainDetail.toStationCode,
          'newToTime': this.trSearchInfo.TrainDetail.arriveTime,
          'newTrainCode': this.trSearchInfo.TrainDetail.trainCode,
          'newTrainNo': this.trSearchInfo.TrainDetail.trainNo,
          'isByidcard': this.trSearchInfo.TrainDetail.isByidcard,
          'orderFrom': getSysType(),
          'orderId': this.id,
          'psgIds': this.CheckPsgList.map(psg => psg.psgId).join(','),
          'chooseSeats':this.chooseSeats,
          'newSeatName':this.trSearchInfo.SeatDetail.seatName//区分是否为无座订单
        }
        const { ids = '' } = await TrainOrderInteractor.submitChange(params)
        this.$store.commit('tr/CLEAR_TRSEARCHINFO')
        if (ids.length === 1) {
          this.$router.push(`/tr/AlterCmp/${ids[0]}`)
        } else {
          this.$dialog({
            confirmButtonText: '前往',
            message: '系统生成两个订单前往订单列表查看',
          }).then(() => {
            this.$router.push({
              path: '/allOrder?findType=1',
              query: { findType: '4' }
            })
          })
        }
      } catch (error) {
        if (typeof error === 'string') this.$dialog.alert({ message: error })
      }
    },
    back() {
      this.$store.commit('tr/CLEAR_TRSEARCHINFO')
      this.$router.push('/allOrder?findType=1')
    }
  },
  computed: {
    ...mapState({
      trSearchInfo: state => state.tr.trSearchInfo,
      newSeatDetail: state => state.tr.trSearchInfo.SeatDetail
    }),
    // 如果选择的是无座，就不展示 `是否接受无座` 和 `选座`
    acceptNoSeatShow () {
      return this.newSeatDetail.seatName !== '无座'
    }
  }
}
</script>

<style lang="less">
.trApplyAlter {
    .mescroll{
    height: calc(100vh - 90px);
  }
  h3 {
    margin: 0;
  }

  padding-bottom: 78px;

  .pad8 {
    padding: 8px;
  }
  .pb0 {
    padding-bottom: 0;
  }
  .mt5 {
    margin-top: 5px;
  }

  .StopStation {
    > .van-row {
      color: @color-text-black;
    }
  }

  .query-btn {
    width: 85px !important;
  }

  .calender-icon {
    font-size: 18px;
    line-height: 24px;
    margin-right: 5px;
  }
}
</style>
